import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse, LoadState } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { SubjectInfo } from "./model";

export interface SubjectState {
  state: LoadStateInfo;
  request?: RetrieveSubjectRequest;
  selected?: SubjectInfo;
}

const initialState: SubjectState = {
  state: notStarted(),
};

export interface RetrieveSubjectRequest {
  subjectId: string;
}

export const retrieveSubject = createAsyncThunk(
  "retrieveSubject",
  async (param: RetrieveSubjectRequest, thunkAPI) => {
    console.debug("retrieve subject");

    const response = await fetch(`${getBackendUrl()}/api/subject/${param.subjectId}`, {
      signal: thunkAPI.signal,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });

    if (response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse(response));
    }
  },
  {
    condition: (param: RetrieveSubjectRequest, thunkAPI) => {
      const state = thunkAPI.getState() as RootState;
      const status = (state as any).subject as SubjectState | undefined;
      if (!status || !status.state) {
        return true;
      }
      if (status.state.state == LoadState.NotStarted) {
        return true;
      }
      console.debug(`retrieveSubject skipped: ${status.state.state}`);
      return false;
    },
  }
);

export const subjectSlice = createSlice({
  name: "subject",
  initialState,
  reducers: {
    select: (state, action: PayloadAction<SubjectInfo | undefined>) => {
      console.trace(`select :: ${action.payload?.name}`);
      state.selected = action.payload;
    },
    check: (state, action: PayloadAction<string | undefined>) => {
      if (
        state.state.state != LoadState.NotStarted &&
        (action.payload == undefined || state.request?.subjectId != action.payload)
      ) {
        state.request = undefined;
        state.state = notStarted();
        state.selected = undefined;
      }
    },
    clean: (state) => {
      state.request = undefined;
      state.selected = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retrieveSubject.pending, (state, action) => {
        state.request = action.meta.arg;
        state.state = loading();
        state.selected = undefined;
      })
      .addCase(retrieveSubject.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.selected = action.payload;
      })
      .addCase(retrieveSubject.rejected, (state, action) => {
        state.state = error(action);
      });
  },
});

// export const { } = subjectSlice.actions;

export const selectSubject = (state: RootState) => (state as any).subject as SubjectState;

export default subjectSlice.reducer;
